// routes
import { paths } from "@/routes/paths";

// API
// ----------------------------------------------------------------------

export const HOST_API = import.meta.env.VITE_APP_HOST_API;
export const ASSETS_API = import.meta.env.VITE_APP_ASSETS_API;

// ROOT PATH AFTER LOGIN SUCCESSFUL
export const PATH_AFTER_LOGIN = paths.test;
// export const PATH_AFTER_LOGIN = paths.dashboard.root; // as '/dashboard'

export const AUTH0_API = {
  clientId: import.meta.env.VITE_APP_AUTH0_CLIENT_ID,
  domain: import.meta.env.VITE_APP_AUTH0_DOMAIN,
  callbackUrl: import.meta.env.VITE_APP_AUTH0_CALLBACK_URL,
};

export const SYEP_API = {
  clientId: import.meta.env.VITE_APP_SYEP_CLIENT_ID,
  domain: import.meta.env.VITE_APP_SYEP_DOMAIN,
  callbackUrl: import.meta.env.VITE_APP_SYEP_CALLBACK_URL,
};

export const NYPL_API = {
  clientId: import.meta.env.VITE_APP_NYPL_CLIENT_ID,
  domain: import.meta.env.VITE_APP_NYPL_DOMAIN,
  callbackUrl: import.meta.env.VITE_APP_NYPL_CALLBACK_URL,
};

export const MAPBOX_API = import.meta.env.VITE_APP_MAPBOX_API;

// export const FIREBASE_API = {
//   apiKey: import.meta.env.VITE_APP_FIREBASE_API_KEY,
//   authDomain: import.meta.env.VITE_APP_FIREBASE_AUTH_DOMAIN,
//   projectId: import.meta.env.VITE_APP_FIREBASE_PROJECT_ID,
//   storageBucket: import.meta.env.VITE_APP_FIREBASE_STORAGE_BUCKET,
//   messagingSenderId: import.meta.env.VITE_APP_FIREBASE_MESSAGING_SENDER_ID,
//   appId: import.meta.env.VITE_APP_FIREBASE_APPID,
//   measurementId: import.meta.env.VITE_APP_FIREBASE_MEASUREMENT_ID,
// };

// export const AMPLIFY_API = {
//   userPoolId: import.meta.env.VITE_APP_AWS_AMPLIFY_USER_POOL_ID,
//   userPoolWebClientId: import.meta.env.VITE_APP_AWS_AMPLIFY_USER_POOL_WEB_CLIENT_ID,
//   region: import.meta.env.VITE_APP_AWS_AMPLIFY_REGION,
// };
